import { useRunEditorQuery } from 'src/generated/graphql';

export function useRunEditor(runId: ID | null) {
  return useRunEditorQuery({
    variables: { runId: runId! },
    skip: runId == null,
  });
}
